import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, subtitle, icon, trend, trendValue, color = 'var(--color-primary)' }) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 md:p-6 shadow-elevation-2 hover:shadow-elevation-4 transition-all duration-300 border border-fintech-blue-100 hover:border-fintech-blue-300 hover:scale-[1.03] hover:-translate-y-1 cursor-pointer group">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center shadow-elevation-1 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3`} style={{ background: `linear-gradient(135deg, ${color}, ${color}dd)` }}>
          <Icon name={icon} size={20} color="#FFFFFF" />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-lg transition-all duration-200 hover:scale-110 ${trend === 'up' ? 'bg-fintech-green-100 border border-fintech-green-300' : 'bg-red-100 border border-red-300'}`}>
            <Icon name={trend === 'up' ? 'ArrowUp' : 'ArrowDown'} size={14} color={trend === 'up' ? '#00AD45' : '#DC2626'} />
            <span className={`text-xs font-bold ${trend === 'up' ? 'text-fintech-green-700' : 'text-red-700'}`}>
              {trendValue}
            </span>
          </div>
        )}
      </div>
      <h3 className="text-sm text-muted-foreground font-medium mb-2 transition-colors duration-200 group-hover:text-foreground">{title}</h3>
      <p className="text-2xl md:text-3xl font-bold text-foreground mb-1 transition-all duration-200 group-hover:scale-105">{value}</p>
      <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>
    </div>
  );
};

export default MetricsCard;